/**
 * Client-side mirror of OTP_FIRST for "try other channel" resend.
 * Set NEXT_PUBLIC_OTP_FIRST=sms when OTP_FIRST=sms so the alternate button sends WhatsApp.
 */

export function alternateSendViaSmsForResend(): boolean {
  return process.env.NEXT_PUBLIC_OTP_FIRST?.toLowerCase().trim() === 'sms'
    ? false
    : true;
}
